import { useState, useEffect } from 'react'
import { CytologyReportPanel } from '@/features/imaging/CytologyReportPanel'

export default function CytologyReportTest() {
  const [showPanel, setShowPanel] = useState(false)
  const [slides, setSlides] = useState<any[]>([])
  const [selectedSlideId, setSelectedSlideId] = useState<string>('')

  useEffect(() => {
    // Load available slides
    const fetchSlides = async () => {
      try {
        const response = await fetch('/api/v1/imaging/slides/')
        if (response.ok) {
          const data = await response.json()
          const slideList = data.results || data
          setSlides(slideList)
          if (slideList.length > 0) {
            setSelectedSlideId(slideList[0].id)
          }
        }
      } catch (error) {
        console.error('Failed to load slides:', error)
      }
    }
    fetchSlides()
  }, [])

  return (
    <div className="container mx-auto p-8">
      <div className="bg-white rounded-lg shadow-lg p-6">
        <h1 className="text-2xl font-bold mb-4">🧪 Test Cytology Report Panel</h1>
        <p className="text-gray-600 mb-6">
          Trang này để test Dynamic Form Renderer với custom fields từ Form Builder.
        </p>

        {/* Slide Selection */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Chọn Slide:
          </label>
          <select
            value={selectedSlideId}
            onChange={(e) => setSelectedSlideId(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="">-- Chọn slide --</option>
            {slides.map((slide) => (
              <option key={slide.id} value={slide.id}>
                {slide.name} ({slide.status})
              </option>
            ))}
          </select>
          {slides.length === 0 && (
            <p className="text-sm text-red-600 mt-1">
              Không có slide nào. Hãy upload slide trước.
            </p>
          )}
        </div>

        <button
          onClick={() => setShowPanel(true)}
          disabled={!selectedSlideId}
          className="bg-purple-600 text-white px-6 py-3 rounded-lg hover:bg-purple-700 font-medium disabled:opacity-50 disabled:cursor-not-allowed"
        >
          🔬 Mở Cytology Report Panel
        </button>

        {showPanel && selectedSlideId && (
          <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex">
            <div className="ml-auto w-2/3 h-full">
              <CytologyReportPanel
                slideId={selectedSlideId}
                annotations={[]}
                onClose={() => setShowPanel(false)}
              />
            </div>
          </div>
        )}
      </div>

      <div className="bg-yellow-50 border-l-4 border-yellow-500 p-6 mt-6">
        <h2 className="font-bold text-lg mb-2">📝 Hướng dẫn:</h2>
        <ol className="list-decimal list-inside space-y-2 text-sm">
          <li>Click nút "Mở Cytology Report Panel" ở trên</li>
          <li>Mở Developer Console (F12) để xem logs</li>
          <li>Tìm log <code className="bg-gray-200 px-1">📋 [CytologyReportPanel]</code></li>
          <li>Scroll xuống dưới form, tìm section "📝 Thông tin bổ sung (Custom Fields)"</li>
          <li>Kiểm tra các custom fields (ABCXYZ, Ngày Tháng Năm) có hiển thị không</li>
        </ol>
      </div>
    </div>
  )
}
